import { Injectable } from '@angular/core';
import {
  GetContactReasonFilter,
  GetContactReasonResponse,
  Macro,
  PagedContactReasonGetAllResponse,
  PagedGetContactReasonResponse,
} from './models/contact-reason.service.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { serializeQueryParams } from 'src/app/service-helper';
import { PagedRequest } from 'src/app/paged-request.model';

@Injectable({
  providedIn: 'root',
})
export class ContactReasonService {
  private baseURL: string = `${environment.apiUrl}/api/ContactReason`;

  constructor(private http: HttpClient) {}

  create(request: FormData) {
    return this.http.post(this.baseURL, request);
  }

  get(
    filter: GetContactReasonFilter
  ): Observable<PagedContactReasonGetAllResponse> {
    const params = serializeQueryParams(filter);
    return this.http.get<PagedContactReasonGetAllResponse>(this.baseURL, {
      params,
    });
  }

  getMacro(request: PagedRequest): Observable<PagedGetContactReasonResponse> {
    const params = serializeQueryParams(request);
    return this.http.get<PagedGetContactReasonResponse>(
      this.baseURL + '/macros',
      {
        params,
      }
    );
  }

  getById(id: string): Observable<GetContactReasonResponse> {
    return this.http.get<GetContactReasonResponse>(this.baseURL + '/' + id);
  }

  update(id: string, request: FormData) {
    return this.http.put(this.baseURL + '/' + id, request);
  }

  delete(id: string) {
    return this.http.delete(this.baseURL + '/' + id);
  }

  downloadFile(id: string) {
    return this.http.get(this.baseURL + '/' + id + '/File', {
      responseType: 'blob',
    });
  }

  downloadTemplate() {
    return this.http.get(this.baseURL + '/template', {
      responseType: 'blob',
    });
  }
}
